;(function() {
  class Head {
    constructor(
      el = null,
      options = {
        waypoint: 200,
        throttleTimeout: 100,
      }
    ) {
      this.el = el
      if (this.el) {
        this.options = options
        this.init()
        return
      }
      throw new Error(`${this.selector} not found in DOM.`)
    }

    init() {
      // this.toggleShrink(window.scrollY)
      this.handleScroll()
    }

    handleScroll() {
      let lastScrollPos = 0
      let timeout = false
      window.addEventListener("scroll", () => {
        lastScrollPos = window.scrollY
        if (!timeout) {
          timeout = setTimeout(() => {
            // this.toggleShrink(lastScrollPos)
            clearTimeout(timeout)
            timeout = false
          }, this.options.throttleTimeout)
        }
      })
    }

    // toggleShrink(scroll) {
    //   const shrunk = this.el.getAttribute("data-shrink") === "true"
    //   if (scroll >= this.options.waypoint && !shrunk) {
    //     // shrink component past waypoint
    //     this.el.setAttribute("data-shrink", "true")
    //   }
    //   if (scroll < this.options.waypoint && shrunk) {
    //     // shrink component past waypoint
    //     this.el.setAttribute("data-shrink", "false")
    //   }
    // }
  }

  function initHead(selector = "#head") {
    const el = document.querySelector(selector)
    el && new Head(el)
  }

  initHead()
})()
